// App.js
import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Root from './pages/Root';
import Home from './pages/Home';
import Categories from './pages/Categories';
import EventDetails from './pages/EventDetails';
import NewEvent from './pages/NewEvent';
import EventRoot from './pages/EventRoot';
import EditCategory from './pages/EditCategory';
import Login from './pages/Login';
import ProtectedRoute from './pages/ProtectedRoute';
import NewCategory from './pages/NewCategory';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import SubCategories from './pages/SubCategories';
import NewSubCategory from './pages/NewSubCategory';
import EditSubCategory from './pages/EditSubCategory';
import Ads from './pages/Ads';
import NewAd from './pages/NewAd';
import EditAd from './pages/editAd';
import Product from './pages/Product';
import Brand from './pages/Brand';
import NewBrand from './pages/NewBrand';
import Packages from './pages/Packages';
import NewPackage from './pages/NewPackage';
import Users from './pages/Users';
import Coupons from './pages/Coupons';
import NewCoupon from './pages/NewCoupon';
import NewAdmin from './pages/NewAdmin';
import Notifications from './pages/Notifications';
import NewNotifcation from './pages/NewNotifcation';

const routes = createBrowserRouter([
  {
    path: 'login',
    element: <Login />
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <Root />,
        children: [
          { index: true, element: <Home /> },
          {
            path: 'Brand',
            element: <EventRoot />,
            children: [
              { index: true, element: <Brand /> },
              { path: 'new-brand', element: <NewBrand /> }
            ]
          },
          {
            path: 'Coupons',
            element: <EventRoot />,
            children: [
              { index: true, element: <Coupons /> },
              { path: 'new-Coupons', element: <NewCoupon /> }
            ]
          },
          {
            path: 'Notifications',
            element: <EventRoot />,
            children: [
              { index: true, element: <Notifications /> },
              { path: 'new-Notifcation', element: <NewNotifcation /> }
            ]
          },

          
          {
            path: 'Categories',
            element: <EventRoot />,
            children: [
              { index: true, element: <Categories /> },
              // { path: 'sub-categories', element: <SubCategories /> },
              { path: ':id', element: <EventDetails /> },
              { path: 'new', element: <NewEvent /> },
              { path: 'edit/:id', element: <EditCategory /> },
              { path: 'new-category', element: <NewCategory /> }
            ]
          },

          {
            path: 'SubCategories',
            element: <EventRoot />,
            children: [
              { index: true, element: <SubCategories /> },
              { path: 'new', element: <NewSubCategory /> },
              { path: 'edit/:id', element: <EditSubCategory /> },


            ]
          },

          {
            path: 'Ads',
            element: <EventRoot />,
            children: [
              { index: true, element: <Ads /> },
              { path: 'new', element: <NewAd /> },
              // { path: 'edit/:id', element: <EditAd /> },
              

            ]
          },
          {
            path: 'Packages',
            element: <EventRoot />,
            children: [
              { index: true, element: <Packages/> },
              { path: 'new', element: <NewPackage/> },

            ]
          },

          {
            path: 'Users',
            element: <EventRoot />,
            children: [
              { index: true, element: <Users/> },
            ]
          },
          {
            path: 'Admins',
            element: <EventRoot />,
            children: [
              { index: true, element: <NewAdmin/> },
            ]
          },
          
          

          {
            path: 'Product',
            element: <EventRoot />,
            children: [
              { index: true, element: <Product /> },
              // { path: 'new', element: <NewAd /> },
              // { path: 'edit/:id', element: <EditAd /> },

            ]
          },

          
        ]
      }
    ]
  }
]);


function App() {

  return <>
  {/* Include ToastContainer here */}
  <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
  <RouterProvider router={routes} />
</>;
}

export default App;
